import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { getProjectStepImg, getProjectStepName } from 'utils/projects';

class Profile extends React.Component {

    state = {
        projects: [],
        canSave: true
    }

    componentWillMount = () => {


        if(!this.props.viewing_user.company) {
            return;
        }

        //TODO: not that this needs to only pull there projects once development improves
        // uncomment the second line
        let projects = this.props.app_projects;
        projects = projects.filter(p =>   p.company._id === this.props.viewing_user.company._id )


        if(projects) {
            this.setState({projects})
        }



    }
    
    render() {

        return (
            <>

            <Container>     

                <Helmet>
                    <title>Projects</title>
                    <meta name="description" content="Projects" />
                </Helmet>

                {this.state.alert}

                {/* <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/dashboard" 
                    title={<span>Dashboard</span>} breadcrumb_1="My Projects"  
                /> */}

         

                        <Card className="mt-4">

                            <CardHeader>
                                <h2 className="mb-0">Welcome To Architeck</h2>
                            </CardHeader>

                            <CardBody>
                                <Row>
                                    <Col lg={2}>
                                        <img alt="..." className="w-100" src="https://architeck.io/static/media/svg7.af42bbfe.svg" />
                                    </Col>
                                    <Col lg={10}>
                                        <h4 className="mt-2 mt-lg-0">Creating the future through hybrid development.</h4>
                                        <p>This is your dashboard for anything and everything to do with your Architeck projects. Stay up to date with the development process, submit feature requests, report bugs, and manage everything related to your application right here! </p>
                                    </Col>
                                
                                </Row>

                            </CardBody>
                        </Card>


                <Row >

                    {this.state.projects.length ? this.state.projects.map(p => (
                        <Col key={p._id} xl={4}>
                            <Link to={"/dashboard/projects/" + p._id}>
                                <Card className="mb-4">
                                    <CardHeader className="text-center">
                                        <h2 className="mb-0">{p.name}</h2>
                                        <h5 className="text-muted">
                                            Status: {getProjectStepName(p.step)}
                                        </h5>

                                    </CardHeader>
                                    <CardBody>
                                        <img src={getProjectStepImg(p.step)} alt="..." className="w-100" />
                                    </CardBody>
                                </Card>
                            </Link>
                        </Col>
                    )): (
                       <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <h2>Your account does not have any projects assigned to it yet.</h2>
                                </CardBody>
                            </Card>
                       </Col>

                    )}
                </Row>

            </Container>
            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_users: state.users.app_users,
      app_projects: state.projects.app_projects,
  
    };
};
  
export default connect(mapStateToProps, '')(Profile);